export const setManifest = (name = "ONMO", url: string) => {
  const myDynamicManifest = {
    scope: url,
    name: name,
    short_name: name,
    id: url,
    start_url: url,
    background_color: "#000000",
    theme_color: "#0f4a73",
    display: "standalone",
    icons: [
      {
        src: `${import.meta.env.VITE_ASSETS_PWA_URL}/favicon.ico`,
        sizes: "64x64 32x32 24x24 16x16",
        type: "image/x-icon",
        purpose: "maskable",
      },
      {
        src: `${import.meta.env.VITE_ASSETS_PWA_URL}/android-icon-192.png`,
        type: "image/png",
        sizes: "192x192",
        purpose: "any",
      },
      {
        src: `${
          import.meta.env.VITE_ASSETS_PWA_URL
        }/android-icon-192-maskable.png`,
        type: "image/png",
        sizes: "192x192",
        purpose: "maskable",
      },
      {
        src: `${import.meta.env.VITE_ASSETS_PWA_URL}/android-icon-512.png`,
        type: "image/png",
        sizes: "512x512",
        purpose: "any",
      },
      {
        src: `${
          import.meta.env.VITE_ASSETS_PWA_URL
        }/android-icon-512-maskable.png`,
        type: "image/png",
        sizes: "512x512",
        purpose: "maskable",
      },
    ],
  };

  const stringManifest = JSON.stringify(myDynamicManifest);
  const blob = new Blob([stringManifest], { type: "application/json" });
  const manifestURL = URL.createObjectURL(blob);
  const div = document.querySelector("#my-manifest-placeholder");

  if (div) {
    div.setAttribute("href", manifestURL);
  }

  const link = document.createElement("Link") as HTMLLinkElement;
  link.rel = "manifest";
  link.setAttribute("href", "data:application/json;charset=8" + stringManifest);
};
